import AuthService from '../../state/auth.service';
import axios from 'axios';

import endpoints from '../endpoints';

const getHeaders = () => {
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `${AuthService.getToken()}`,
    };
};

export default {
    delete(id) {
        // console.log("deleting an practice", id);
        return axios
            .delete(endpoints.PRACTICE_BASE + '/' + id, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },

    create(organization_id, fields) {
        fields.organization_id = organization_id;
        return axios
            .post(endpoints.PRACTICE_BASE, fields, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                let msg = `Error creating practice for organization ${organization_id}`;
                if (err.response.data.message) {
                    msg = err.response.data.message;
                }
                throw msg;
            });
    },

    get(id) {
        return axios
            .get(endpoints.PRACTICE_BASE + '/' + id, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                let msg = `Error updating practice "${id}"`;
                if (error.response.data.message) {
                    msg = error.response.data.message;
                }
                throw msg;
            });
    },

    getAllForOrganization(organizationId) {
        return axios
            .get(`${endpoints.ORGANIZATION_BASE}/${organizationId}/practices`, {
                headers: getHeaders(),
            })
            .then(response => {
                if (response.data) {
                    return response.data;
                }
            });
    },

    removeMember(practiceId, userId) {
        return axios
            .delete(
                `${endpoints.PRACTICE_BASE}/${practiceId}/member/${userId}`,
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                if (response.data) {
                    return response.data;
                } else {
                    return false;
                }
            });
    },

    update(practiceId, body) {
        return axios
            .put(endpoints.PRACTICE_BASE + '/' + practiceId, body, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                let msg = `Error updating practice "${practiceId}"`;
                if (error.response && error.response.data.message) {
                    msg = error.response.data.message;
                }
                throw msg;
            });
    },

    addMember(practiceId, userId, roleId) {
        return axios
            .post(
                `${endpoints.PRACTICE_BASE}/${practiceId}/member`,
                {
                    role_id: roleId,
                    user_id: userId,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                if (response.data) {
                    return response.data;
                } else {
                    return false;
                }
            });
    },

    getMembers(practiceId) {
        return axios
            .get(`${endpoints.PRACTICE_BASE}/${practiceId}/members`, {
                headers: getHeaders(),
            })
            .then(response => {
                if (response.data) {
                    return response.data;
                }
            });
    },

    listCriteria(practiceId) {
        const url = `${endpoints.PRACTICE_BASE}/${practiceId}/criteria`;
        return axios
            .get(url, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },

    listEvents(practiceId) {
        return axios
            .get(`${endpoints.PRACTICE_BASE}/${practiceId}/events`, {
                headers: getHeaders(),
            })
            .then(response => {
                if (response.data) {
                    return response.data;
                }
            });
    },

    getDetails(practiceId) {
        return axios
            .get(`${endpoints.PRACTICE_BASE}/${practiceId}/details`, {
                headers: getHeaders(),
            })
            .then(response => {
                if (response.data) {
                    return response.data;
                }
            });
    },
};
